<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/58/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/55/title-1.png" alt="" />
                    <div class="content">
                        “金堂工匠”评选对象面向本县所有职工（含农民工），重点聚焦现代化开放型产业体系中的一线工人，不受年龄、学历、资历和身份等限制。
                    </div>
                </div>
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/55/title-2.png" alt="" />
                    <div class="content">申报人选具体条件，详见申报通知。</div>
                </div>

                <div class="zccl">
                    <img class="top" src="./../assets/imgs/27/title-3.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="title">一. 资金支持</div>
                            不超过 3 万元资助资金。
                        </div>
                        <div class="des">
                            <div class="title">二、住房保障</div>
                            按规定享受人才购房或人才公寓政策支持。
                        </div>
                        <div class="des">
                            <div class="title">三、子女入学</div>
                            按规定享受子女入学政策支持。
                        </div>
                        <div class="des">
                            <div class="title">四.交流培训</div>
                            可参加技能专班培训。
                        </div>
                    </div>
                </div>
                <div class="gmlc">
                    <img class="top" src="./../assets/imgs/55/title-4.png" alt="" />
                    <div class="content">
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">公告阶段</div>
                                </div>
                                <div class="line-content">
                                    <div style="font-weight: bold">
                                        县总工会发布人才评选公告，相关单位组织动员各领域人才参评
                                    </div>
                                    <div style="
                                                width: 100%;
                                                height: 0.005rem;
                                                background-color: #3d5aa3;
                                                margin-top: 0.22rem;
                                                margin-bottom: 0.22rem;
                                            "></div>
                                    所需资料：<br />
                                    1.申请人有效期内的身份证，学历证书、学位证书，职业资格证书等<br />
                                    2.申请人所在企事业单位工作关系证明<br />
                                    3.取得荣誉证书复印件，重大成果佐证资料<br />
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line" style="height: 100%"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">审核阶段</div>
                                </div>
                                <div class="line-content">
                                    <div style="font-weight: bold">
                                        各行业主管部门对人才资格条件进行初审。县总工会组织有关单位和专家组成评审组开展综合评审。
                                    </div>
                                    <div style="
                                                width: 100%;
                                                height: 0.005rem;
                                                background-color: #3d5aa3;
                                                margin-top: 0.22rem;
                                                margin-bottom: 0.22rem;
                                            "></div>
                                    所需资料：<br />
                                    1.申请人有效期内的身份证，学历证书、学位证书，职业资格证书等<br />
                                    2.申请人所在企事业单位工作关系证明<br />
                                    3.取得荣誉证书复印件，重大成果佐证资料<br />
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">认定阶段</div>
                                </div>
                                <div class="line-content">
                                    <div style="font-weight: bold">
                                        通过网络、报纸等媒体对“金堂工匠”候选人名单进行社会公示，接受社会监督，公示时间不少于5个工作日，公示无异议后，报请县委人才工作领导小组审批认定，由县总工会牵头兑现激励。
                                    </div>
                                    <div style="
                                                width: 100%;
                                                height: 0.005rem;
                                                background-color: #3d5aa3;
                                                margin-top: 0.22rem;
                                                margin-bottom: 0.22rem;
                                            "></div>
                                    所需资料：初评结果、公示材料
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contact" style="margin-top: 0.8rem">
                    <img class="top" src="./../assets/imgs/25/title-5.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-84921851">028-84921851</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            金堂县总工会
                        </div>
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/58/code.png" />
                    <img class="text" src="../assets/imgs/58/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 4.4rem;
    }

    .technological-process {
        transform: translateY(-1.3rem);

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                background: #ffffff;
                font-size: 0.26rem;
                color: #4e4e4e;
                text-align: left;
                position: relative;
                font-weight: 500;
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.22rem;
                    position: relative;
                }
            }
        }

        .zccl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;
                    text-align: left;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 2.98rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 130%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }

                        .line-top {
                            display: flex;
                            width: 3.31rem;
                            height: 0.49rem;
                            background-image: url(../assets/imgs/25/label.png);
                            background-size: 100% 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding-left: 0.08rem;

                            .line-num {
                                width: 0.39rem;
                                height: 0.39rem;
                                background: #fff;
                                color: #3d5aa3;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.28rem;
                                font-weight: bold;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                height: 1.65rem;
            }
        }
    }
}
</style>
